import emojiRegex from 'emoji-regex';
import { calculateTime, emojiMap, emojis, stickers } from '../global-components/src/utils/text';
import { t } from 'i18next';

export function errorMessage(err: any) {
    if (err.status == 401){
        return t("generics.errors.sessionExpired");
    }

    else if (err.status == 429 && err.message.blocked)
        return t("generics.errors.tooManyRequests", { minutes: err.remaining });

    else if (err.status == 429){
        if(err.response.data.message == "blocked"){
           return t("generics.errors.tooManyRequests", { minutes: err.remaining });
        }
        
        if (err?.response?.data?.message)
            return err.response.data.message;

        return t("generics.errors.tooManyRequestsGeneric");
    }

    else if (err?.response?.data?.message) {
        return err.response.data.message;

    } else if (err?.response?.data.error) {
        return t("generics.errors.serverError", { error: err.response.data.error });

    } else if (err.response?.data.erro) { //gerencianet
        return err.response.data.erro;

    } else if (err.message) { //gerencianet
        return err.message;

    } else if (err.request) {
        if(err.code == "ERR_NETWORK")
            return  t("generics.errors.networkError");

        return t("generics.errors.genericServerError");
    } else {
        return t("generics.errors.genericError");
    }
}



const emojisAndStickers = {
    ...stickers,
    ...emojis,
};

export function replaceEmojis(text: string) {
    return replaceDefaultEmojis(Object.keys(emojisAndStickers).reduce((acc, key) => {
        return acc.replace(new RegExp(key, 'g'), emojisAndStickers[key]);
    }, text));
}

export function replaceDefaultEmojis(text: string) {
    const regex = emojiRegex();

    return text.replace(regex, (emoji) => {
        const nome = emojiMap[emoji];
        if (nome && emojis[nome]) {
            return emojis[nome];
        }
        return emoji;
    });
}

export { calculateTime };